export const ACCOUNTS_CARDS_ROUTES = { accounts: 'accounts', cards: 'cards' } as const;

type LangRoute = `/:lang/${string}`;

export const DIGITAL_ACCOUNT_ROUTES = {
  base: 'digital-account',
  review: 'review',
  consent: 'aggreement-sign',
  progress: 'progress',
  currency: 'currency',
  'company-info': 'company-info',
  shareholders: 'shareholders',
  'business-request': 'business-request',
  'print-forms': 'print-forms',
  videocall: 'videocall',
  'request-accepted': 'request-accepted',
  'identify-failed': 'identify-failed',
  'unsupported-file-error': 'unsupported-file-error',
  'insufficient-file-error': 'insufficient-file-error',
  'existing-onboarding-succeed': 'existing-onboarding-succeed',
  'aml-check-waiting': 'aml-check-waiting',
};

export const getDigitalAccountRoute = (key: keyof typeof DIGITAL_ACCOUNT_ROUTES) =>
  `/:lang/${DIGITAL_ACCOUNT_ROUTES.base}${DIGITAL_ACCOUNT_ROUTES[key]}`;

const ROUTES: Record<string, LangRoute> = {
  login: '/:lang/login',
  recovery: '/:lang/recovery',
  linkSent: '/:lang/recovery/link-sent',
  linkConfirm: '/:lang/password_recovery',
  setNewPass: '/:lang/new-password',
  confirmAsanImza: '/:lang/authorization/confirm-asan-imza',
  otp: '/:lang/authorization/otp',
  register: '/:lang/register',
  registerOtp: '/:lang/register/otp',
  registerSelectCompany: '/:lang/register/select-company',
  selectCompany: '/:lang/company-login',
  docSign: '/:lang/document-sign',
  homePage: '/:lang/home-page',
  transferPage: '/:lang/transfer-page',
  transferPageV2: '/:lang/transfer-page-v2',
  foreignTransfer: '/:lang/transfer-page/payment_foreign_transfer',
  lastOperations: '/:lang/last-operations',
  paymentOrdersPage: '/:lang/payment-orders',
  templatesPage: '/:lang/templates-page',
  newTemplate: '/:lang/templates-page/new-template',
  editTemplate: '/:lang/templates-page/edit-template',
  signedOperations: '/:lang/signed-operations',
  accountsCards: '/:lang/accounts-card',
  cardOrder: '/:lang/card-order',
  salaryPage: '/:lang/salary',
  salaryCardPage: '/:lang/salary-card',
  salaryCardOrder: '/:lang/salary-card/order',
  salaryCardExtension: '/:lang/salary-card/extension',
  salaryCardExtensionPhoneNumbers: '/:lang/salary-card/extension/phone-numbers',
  salaryCardExtensionSuccess: '/:lang/salary-card/extension/success',
  salaryCardApplications: '/:lang/salary-card/applications',
  clientProfile: '/:lang/profile',
  createUser: '/:lang/create-user',
  employeeAdd: '/:lang/add-employee',
  creditsPage: '/:lang/credits',
  creditLine: '/:lang/credit-line',
  creditLineDetails: '/:lang/credit-line/details',
  creditLineUsage: '/:lang/credit-line/usage',
  creditLineUsageConfirm: '/:lang/credit-line/usage/confirm',
  creditLineUsageSuccess: '/:lang/credit-line/usage/success',
  depositsPage: '/:lang/deposits',
  ordersPage: '/:lang/orders',
  guaranteeOrderPage: '/:lang/guarantee',
  guaranteeV2Page: '/:lang/guarantee-v2',
  guaranteeV2NewApplication: '/:lang/guarantee-v2/new-application',
  guaranteeV2TenderDetails: '/:lang/guarantee-v2/new-application/tender-details',
  guaranteeV2OrderInfo: '/:lang/guarantee-v2/new-application/order-info',
  guaranteeV2DocumentUpload: '/:lang/guarantee-v2/new-application/document-upload',
  guaranteeV2Confirmation: '/:lang/guarantee-v2/new-application/confirmation',
  guaranteeV2Signing: '/:lang/guarantee-v2/new-application/signing',
  loanPage: '/:lang/loan',
  loanOfferConfirmation: '/:lang/loan/offer/:tx_fid/confirmation',
  loanOfferCompleted: '/:lang/loan/offer/:tx_fid/completed',
  loanOfferDeclined: '/:lang/loan/offer/:tx_fid/declined',
  aniPay: '/:lang/ani-pay',
  governmentPaymentPortal: '/:lang/government-payment-portal',
  notHasAccess: '/:lang/not-has-access',
  soon: '/:lang/soon',
  preFlightFee: '/:lang/pre-flight-fee',
  buttonTest: '/:lang/button-test',
  onboarding: '/:lang/onboarding',
};

export default ROUTES;
